import { TellentNavigationItem, TellentNavigationLink } from '@core/tellent-types';

export function findFirstLink(items: TellentNavigationItem[]) {
  const link = items.find(c => c.type === 'link');
  return link ? <TellentNavigationLink>link : undefined;
}
